<template>  
  <sui-page-contents>      
    <sui-grid ref="grid" :columns="gridColumns0" :showMoveControl="true" :autoheight="false" :pageable="true" :autoShrink="true" :dataset="'dataset0'" :initialPagesize="5" :filterable="false" :sortable="false" :multiselect="true">
    </sui-grid>
  </sui-page-contents>  
</template>
<script>
  import LangSelect from '~common/components/form/SuiLangSelect/SuiLangSelect';
  export default {
    name: 'DatasetWithComponent',
    data() {
      return {
        stateOptionList: [
          {
            type: 'complete',
            key: 'complete',
            clickable: 'true',
            label: '완료'
          },
          {
            type: 'complete',
            key: 'before-complete',
            clickable: 'true',
            label: '완료전'
          },
          {
            key: 'cancel',
            type: 'cancel',
            label: '취소'
          },
          {
            key: 'waiting',
            type: 'waiting',
            label: '대기'
          },
        ],
        myToolTip: 'my tool tip',
        multiSelectOptions: [{
            key: 'm1',
            label: 'aulti1',
          },
          {
            key: 'm2',
            label: 'bulti2',
          },
          {
            key: 'm3',
            label: 'culti3',
          },
          {
            key: 'm4',
            label: 'dulti4',
          },
          {
            key: 'm11',
            label: 'aulti1',
          },
          {
            key: 'm12',
            label: 'bulti2',
          },
          {
            key: 'm13',
            label: 'culti3',
          },
          {
            key: 'm14',
            label: 'dulti4',
          },
          {
            key: 'm21',
            label: 'aulti1',
          },
          {
            key: 'm22',
            label: 'bulti2',
          },
          {
            key: 'm23',
            label: 'culti3',
          },
          {
            key: 'm24',
            label: 'dulti4',
          },
        ],
        multiSelected: [],
        selectedUser: {
          userName: '',
          epid: '',
        },
        rangeDate: {
          start: "2019-11-10",
          end: '2019-11-15'
        },
        rangeDateString: null,
        pageUsePriodStartDatetime: new Date(),
        // pageUsePriodStartDatetime: "2000-01-01",
        pageUsePriodFinishDatetime: "2100-10-10",
        cellEditorMap: {},
        customOpitonList: [{
          key: '',
          label: 'AAA'
        }, ],
        selected: {
          md: {
            key: '',
            label: ''
          },
          smd: {
            key: '',
            label: ''
          },
          code: {
            key: '',
            label: ''
          },
          lang: {
            key: '',
            label: ''
          },
          yn: {
            key: '',
            label: ''
          },
          custom: {
            key: '개발',
            label: ''
          },
          customlang: {
            key: '',
            label: ''
          },
        },
        customOptions: [{
            key: 'D',
            label: '개발'
          },
          {
            key: 'F',
            label: '완료'
          },
        ],
        mdDisabled: false,
        pageName: '',
        pagePopupYn: '',
        checked: false,
        gridColumns0: [
          {
              text: 'rowId',
              datafield: 'dataset-row-id',
              width: '50px',
          },
          {
            text: '버튼',
            datafield: 'buttonList',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
                handler: this.onGridButtonClicked
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign: 'right',
            width: '200px',
          },
          {
            text: '버튼',
            datafield: 'button',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onGridSingleButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign: 'left',
            width: '150px',
          },
          {
            text: '페이지 명',
            datafield: 'textarea',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellTextarea(row, column, value, htmlElement, {
                checkEditableFunction: this.checkEditableName,
                positiveButtonText: "오픈",
                negativeButtonText: "닫기",
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
          },          
          {
            text: '멀티선택',
            datafield: 'multiselect',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellMultiSelect(row, column, value, htmlElement, {
                optionList: this.multiSelectOptions,
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '150px',
          },
          {
            text: '진행 상태',
            datafield: 'state',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellBadge(row, column, value, htmlElement,
                 { optionList: this.stateOptionList, handler: this.onGridStateClicked }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '250px',
          },
          {
            text: '사용여부',
            datafield: 'pageUseYn',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            rowspan: this.rowSpan,
            width: '250px',
          },
          {
            text: '삭제여부',
            datafield: 'deleteYn',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellCheckbox(row, column, value, htmlElement, {}, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            width: '250px',
            cellClassName: 'ta_c',
          },
          {
            text: '버튼1',
            datafield: 'button1',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onGridSingleButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign: 'right',
            width: '250px',
          },
          {
            text: '버튼2',
            datafield: 'button2',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onGridSingleButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign: 'right',
            width: '250px',
          },
          {
            text: '버튼3',
            datafield: 'button3',
            createwidget: (row, column, value, htmlElement) => {
              const editorInstance = utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
                handler: this.onGridSingleButtonClicked,
                type: 'link',
              }, this.dataset0, this.$refs.grid);
            },
            initwidget(row, column, value, htmlElement) {
              utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
            },
            cellsalign: 'right',
            width: '250px',
          },
        ],        
        localdata: [],
        localdata0: [{
            "deleteYn": '',
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00001",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00001",
            "pageId": "PGE_CMS_00000",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "Y",
            "pageUsePriodYn": "Y",
            "pageUsePriodStartDatetime": "2019-05-10",
            "pageUsePriodFinishDatetime": "9999-12-31",
            "pagePopupYn": "Y",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-10~2019-02-15',
            'button': 'btn02',
            'buttonList': [{
              label: 'link',
              key: 'btn01',
              type: 'link'
            },
            {
              label: 'linkB',
              key: 'btn01',
              type: 'linkB'
            },
            {
              label: 'sublink',
              key: 'btn02',
              type: 'sublink'
            },
            {
              label: 'sublinkB',
              key: 'btn02',
              type: 'sublinkB'
            },],
            'time': '11:52',
            'state': 'complete',
            'multiselect': 'm1, m3',
            'textarea' : "long text long long ;;longlonglong",
            'button1': 'btn01',
            'button2': 'btn02',
            'button3': 'btn03',
          },
          {
            "deleteYn": "Y",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00003",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00003",
            "pageId": "PGE_CMS_00001",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "N",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-11",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "Y",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-11~2019-02-16',
            'button': 'btn03',
            'buttonList': [{
              label: 'btn21',
              key: 'btn01',
              type: 'positive',
              disabled: true,
            }, {
              label: 'btn22',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '12:12',
            'state': 'waiting',
            'multiselect': 'm1, m2, m3',
            'textarea' : "long text long long ;;longlonglong",
            'button1': 'btn01',
            'button2': 'btn02',
            'button3': 'btn03',            
          },
          {
            "deleteYn": "N",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00005",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00005",
            "pageId": "PGE_CMS_00002",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "Y",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-13",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-12~2019-02-17',
            'button': 'btn04',
            'buttonList': [{
              label: 'btn33',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn32',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn01',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '14:52',
            'state': 'cancel',
            'multiselect': 'm1, m2, m4',
            'textarea' : "long text long long ;;longlonglong"
          },
          {
            "deleteYn": "N",
            "firstRegistrationDTM": "20190510125920",
            "firstRegistrationUserId": "chiwoo.seo",
            "firstRegistrationProgramId": "PGE_CMU_00002",
            "finalModificationDTM": "2019-05-10 12:59:20",
            "finalModificationUserId": "chiwoo.seo",
            "finalModificationProgramId": "PGE_CMU_00002",
            "pageId": "PGE_CMS_00003",
            "moduleCode": "CM",
            "subModuleCode": "S",
            "pageName": "배치작업이력",
            "pageTitleMessageResourceId": "MSG_CM_TIT_BCJB_HIS",
            "pageTypeCode": "N",
            "pageDestinationValue": "/CM/pages/S/PGE_CMS_00005.vue",
            "pageStatusCode": "D",
            "pageBlockContent": "차단된 페이지입니다.",
            "pageUseYn": "N",
            "pageUsePriodYn": "N",
            "pageUsePriodStartDatetime": "2019-05-14",
            "pageUsePriodFinishDatetime": "9999-12-30",
            "pagePopupYn": "N",
            "pagePopupOptionValue": null,
            "searchPageCond": null,
            "searchPageText": null,
            "lang": 'en',
            'rangeDate': '2019-01-14~2019-02-18',
            'button': 'www.naver.com',
            'buttonList': [{
              label: 'btn44',
              key: 'btn01',
              type: 'positive'
            }, {
              label: 'btn42',
              key: 'btn02',
              type: 'negative'
            }, {
              label: 'btn01',
              key: 'btn02',
              type: 'negative'
            }],
            'time': '17:17',
            'state': 'before-complete',
            'multiselect': 'm1, m4',
            'textarea' : "long text long long ;;longlonglong"
          },
        ],
      };
    },
    mounted() {
      const newData = [];
      for (let i = 0; i < 1; i++) {
        this.localdata0.forEach(data => {
          newData.push(_.clone(data));
        });
      }
      // this.dataset0.setRawData(this.localdata0[0]);
      this.dataset0.setRawData(newData);
      // this.dataset0.$on(this.dataset0.EVENTS.DATA_CHANGED, this.datasetUpdate);
      // this.dataset0.$on(this.dataset0.EVENTS.DATAFIELDS_CHANGED, this.datasetUpdate);
      // this.dataset0.$on(this.dataset0.EVENTS.RAW_DATA_CHANGED, this.datasetUpdate);
    },
    datasets: [{
      id: 'dataset0',
      type: 'local',
      data: 'localdata',
      datafields: [{
          "name": "deleteYn",
          "type": "string",
          "map": "deleteYn"
        },
        {
          "name": "firstRegistrationDTM",
          "type": "string",
          "map": "firstRegistrationDTM"
        },
        {
          "name": "firstRegistrationUserId",
          "type": "string",
          "map": "firstRegistrationUserId"
        },
        {
          "name": "firstRegistrationProgramId",
          "type": "string",
          "map": "firstRegistrationProgramId"
        },
        {
          "name": "finalModificationDTM",
          "type": "string",
          "map": "finalModificationDTM"
        },
        {
          "name": "finalModificationUserId",
          "type": "string",
          "map": "finalModificationUserId"
        },
        {
          "name": "finalModificationProgramId",
          "type": "string",
          "map": "finalModificationProgramId"
        },
        {
          "name": "pageId",
          "type": "string",
          "map": "pageId"
        },
        {
          "name": "moduleCode",
          "type": "string",
          "map": "moduleCode"
        },
        {
          "name": "subModuleCode",
          "type": "string",
          "map": "subModuleCode"
        },
        {
          "name": "pageName",
          "type": "string",
          "map": "pageName"
        },
        {
          "name": "pageTitleMessageResourceId",
          "type": "string",
          "map": "pageTitleMessageResourceId"
        },
        {
          "name": "pageTypeCode",
          "type": "string",
          "map": "pageTypeCode"
        },
        {
          "name": "pageDestinationValue",
          "type": "string",
          "map": "pageDestinationValue"
        },
        {
          "name": "pageStatusCode",
          "type": "string",
          "map": "pageStatusCode"
        },
        {
          "name": "pageBlockContent",
          "type": "string",
          "map": "pageBlockContent"
        },
        {
          "name": "pageUseYn",
          "type": "string",
          "map": "pageUseYn"
        },
        {
          "name": "pageUsePriodYn",
          "type": "string",
          "map": "pageUsePriodYn"
        },
        {
          "name": "pageUsePriodStartDatetime",
          "type": "string",
          "map": "pageUsePriodStartDatetime"
        },
        {
          "name": "pageUsePriodFinishDatetime",
          "type": "string",
          "map": "pageUsePriodFinishDatetime"
        },
        {
          "name": "pagePopupYn",
          "type": "string",
          "map": "pagePopupYn"
        },
        {
          "name": "pagePopupOptionValue",
          "type": "string",
          "map": "pagePopupOptionValue"
        },
        {
          "name": "searchPageCond",
          "type": "string",
          "map": "searchPageCond"
        },
        {
          "name": "searchPageText",
          "type": "string",
          "map": "searchPageText"
        },
        {
          "name": "lang",
          "type": "string",
          "map": "lang"
        },
        {
          "name": "rangeDate",
          "type": "string",
          "map": "rangeDate"
        },
        {
          "name": "buttonList",
          "type": "object",
          "map": "buttonList"
        },
        {
          "name": "button",
          "type": "string",
          "map": "button"
        },
        {
          "name": "state",
          "type": "object",
          "map": "state"
        },
        {
          "name": "dataset-row-id",
          "type": "string",
          "map": "dataset-row-id"
        },
        {
          "name": "textarea",
          "type": "string",
          "map": "textarea"
        },
        {
          "name": "multiselect",
          "type": "string",
          "map": "multiselect"
        },
        {
          "name": "button1",
          "type": "string",
          "map": "button1"
        },
        {
          "name": "button2",
          "type": "string",
          "map": "button2"
        },
        {
          "name": "button3",
          "type": "string",
          "map": "button3"
        },
      ]
    },{
      id: 'dataset1',
      type: 'local',
      data: 'localdata1',
      datafields: [{
          "name": "deleteYn",
          "type": "string",
          "map": "deleteYn"
        },
        {
          "name": "firstRegistrationDTM",
          "type": "string",
          "map": "firstRegistrationDTM"
        },
        {
          "name": "firstRegistrationUserId",
          "type": "string",
          "map": "firstRegistrationUserId"
        },
        {
          "name": "firstRegistrationProgramId",
          "type": "string",
          "map": "firstRegistrationProgramId"
        },
        {
          "name": "finalModificationDTM",
          "type": "string",
          "map": "finalModificationDTM"
        },
        {
          "name": "finalModificationUserId",
          "type": "string",
          "map": "finalModificationUserId"
        },
        {
          "name": "finalModificationProgramId",
          "type": "string",
          "map": "finalModificationProgramId"
        },
        {
          "name": "pageId",
          "type": "string",
          "map": "pageId"
        },
        {
          "name": "moduleCode",
          "type": "string",
          "map": "moduleCode"
        },
        {
          "name": "subModuleCode",
          "type": "string",
          "map": "subModuleCode"
        },
        {
          "name": "pageName",
          "type": "string",
          "map": "pageName"
        },
        {
          "name": "pageTitleMessageResourceId",
          "type": "string",
          "map": "pageTitleMessageResourceId"
        },
        {
          "name": "pageTypeCode",
          "type": "string",
          "map": "pageTypeCode"
        },
        {
          "name": "pageDestinationValue",
          "type": "string",
          "map": "pageDestinationValue"
        },
        {
          "name": "pageStatusCode",
          "type": "string",
          "map": "pageStatusCode"
        },
        {
          "name": "pageBlockContent",
          "type": "string",
          "map": "pageBlockContent"
        },
        {
          "name": "pageUseYn",
          "type": "string",
          "map": "pageUseYn"
        },
        {
          "name": "pageUsePriodYn",
          "type": "string",
          "map": "pageUsePriodYn"
        },
        {
          "name": "pageUsePriodStartDatetime",
          "type": "string",
          "map": "pageUsePriodStartDatetime"
        },
        {
          "name": "pageUsePriodFinishDatetime",
          "type": "string",
          "map": "pageUsePriodFinishDatetime"
        },
        {
          "name": "pagePopupYn",
          "type": "string",
          "map": "pagePopupYn"
        },
        {
          "name": "pagePopupOptionValue",
          "type": "string",
          "map": "pagePopupOptionValue"
        },
        {
          "name": "searchPageCond",
          "type": "string",
          "map": "searchPageCond"
        },
        {
          "name": "searchPageText",
          "type": "string",
          "map": "searchPageText"
        },
        {
          "name": "lang",
          "type": "string",
          "map": "lang"
        },
        {
          "name": "rangeDate",
          "type": "string",
          "map": "rangeDate"
        },
        {
          "name": "buttonList",
          "type": "object",
          "map": "buttonList"
        },
        {
          "name": "button",
          "type": "string",
          "map": "button"
        },
        {
          "name": "state",
          "type": "object",
          "map": "state"
        },
        {
          "name": "dataset-row-id",
          "type": "string",
          "map": "dataset-row-id"
        },
        {
          "name": "textarea",
          "type": "string",
          "map": "textarea"
        },
        {
          "name": "multiselect",
          "type": "string",
          "map": "multiselect"
        },
        {
          "name": "button1",
          "type": "string",
          "map": "button1"
        },
        {
          "name": "button2",
          "type": "string",
          "map": "button2"
        },
        {
          "name": "button3",
          "type": "string",
          "map": "button3"
        },
      ]
    }],
    methods: {
      onClicked() {
        this.myToolTip = 'tooltip changed';
      },
      onCodeLoaded(optionsList) {
        optionsList.push({
          key: 'N',
          label: 'NN'
        });
      },
      datasetUpdate() {
        console.log('update');
      },
      onTestClicked() {
        this.dataset0.data[0]['pageId'] = 'TEST';
      },
      onRangeChanged(value) {
        console.log(this.rangeDate);
        console.log(value);
      },
      onGridSingleButtonClicked(value, dataRow) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${value}`, null);
        console.log(dataRow);
      },
      onGridButtonClicked(btn, dataRow) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${btn.label}`, null);
        console.log(dataRow);
      },
      onGridStateClicked(stateOption, dataRow) {
        utils.messageBox('information', '버튼이 클릭되었습니다. 엔터를 누르세요', `label: ${stateOption.type}`, null);
        console.log(dataRow);
      },
      onChangeMode() {
        this.$refs.grid.getCellEditor(0, 'pageName').getComponentInstance().setEditable(true);
      },
      checkEditableName(rowData, columnName, dataset, grid) {
        if (rowData['pageUseYn'] === 'Y') {
          return true
        }
        return false;
      },
      checkEditableState(rowData, columnName, dataset, grid) {
        if (rowData['deleteYn'] === 'Y') {
          return true
        }
        return false;
      },
      onTextFieldWithBtnClicked(event, dataRow) {
        console.log(dataRow);
      },
      rowSpan(row, col, value) {
        if (value === 'Y') {
          return 2;
        }
        return 1;
      },
    }
  };
</script>
<style scoped></style>
